import { Box, BoxProps } from '../box/box';
import { stack } from './stack.css';
import { clsx } from 'clsx';

export type StackProps = BoxProps;

export const Stack = <T extends HTMLElement = HTMLDivElement>(props: BoxProps<T>) => {
  return <Box {...props} className={clsx(stack, props.className)} />;
};
